var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandmarkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3997 1.11177C6.65138 1.97876 4.15954 5.03806 4.13692 8.80062C4.12924 10.0707 4.33724 11.0023 4.89895 12.2143C5.19548 12.8541 11.4959 22.4712 11.9407 22.963C12.0559 23.0903 18.6386 13.211 19.0957 12.2246C19.6623 11.0025 19.8703 10.0736 19.8626 8.80062C19.8416 5.29492 17.6472 2.36084 14.2398 1.28201C13.2857 0.980038 11.3421 0.893851 10.3997 1.11177ZM11.2401 2.58196C6.92775 3.01876 4.38514 7.75646 6.35687 11.6806C6.8085 12.5795 11.8485 20.1073 11.9987 20.1073C12.1349 20.1073 17.0859 12.7376 17.5162 11.8944C18.0231 10.9011 18.245 10.156 18.313 9.21812C18.5501 5.95028 16.0186 2.9234 12.7651 2.58462C12.3442 2.54078 11.6579 2.53961 11.2401 2.58196ZM10.9127 6.77748C9.42332 7.51966 9.20924 9.57022 10.5093 10.6419C12.2219 12.0535 14.7668 10.5026 14.2865 8.33993C13.9496 6.82281 12.3285 6.07198 10.9127 6.77748ZM11.2531 7.45246C10.6867 7.80222 10.5225 8.07134 10.4769 8.72457C10.4413 9.23209 10.4759 9.39454 10.6836 9.69641C10.8209 9.89588 11.1011 10.1507 11.3064 10.2629C12.0057 10.645 13.0185 10.3121 13.3998 9.57481C13.6484 9.09406 13.5539 8.18974 13.2176 7.82964C12.6627 7.23572 11.855 7.08062 11.2531 7.45246Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarkicon);
export default __webpack_public_path__ + "static/media/landmark icon.816d1d7bbd1b2a1eded619b450321020.svg";
export { ForwardRef as ReactComponent };